export function getCountModulesUnlocked(state) {
  let count = 0;
  state.modulesValue.forEach((element) => {
    if (element.unlocked) {
      count++;
    }
  });
  return count;
}

export function getIsModulesActive(state) {
  return state.modulesValue;
}

export function getModulesList(state) {
  return state.modulesList;
}

export function getSelfManagementIsActive(state) {
  let response = false;
  // if ( state.modulesValue.length > 1) {
  //   response = true
  // }

  state.modulesValue.forEach((element) => {
    if (element.module_order == 5) {
      if (element.unlocked) {
        response = true;
      }
    }
  });
  return response;
}

export function moduleInfo(state) {
  const moduleInfo = {
    name: state.lessons[0]?.module_name || 'Title',
    img: `modules-0${state.lessons[0]?.module_order}`,
    lessons: state.lessons.length || 0,
    progress: state.lessons.reduce((acc, cv) => (cv.viewed ? (acc += 1) : acc), 0),
  };
  return moduleInfo;
}

export const lessonById = (state) => (id) => {
  return state.lessons.find((lesson) => lesson.id === Number(id));
};

